export default {
  about_this_app: 'Über diese App',
  activate_users: 'Mitglied(er) aktivieren',
  active: 'Aktiv',
  active_filters: '{{number}} Filter aktiv',
  address: 'Adresse',
  add_gym: 'Sporthalle hinzufügen',
  add_player: 'Spieler hinzufügen',
  add_players: 'Spieler hinzufügen',
  add_team: 'Mannschaft hinzufügen',
  add_user: 'Nutzer hinzufügen',
  add_widget: 'Widget hinzufügen',
  admin: 'Admin',
  administration: 'Verwaltung',
  age: {
    title: 'Alter',
    min: 'Mindestalter',
    max: 'Höchstalter',
    team_settings: {
      info: 'Hier kannst du die Altersklasse deiner Mannschaft festlegen. Die Einstellung wird verwendet, um Interessenten automatisch der passenden Mannschaft zuzuweisen.',
    },
  },
  agb: 'Allgemeine Geschäftsbedingungen',
  all_coaches: 'Alle Trainer',
  all_players: 'Alle Spieler',
  all_referees: 'Alle Schiedsricher',
  archive: 'Archiv',
  association: 'Verband',
  at_away_games: 'An Auswärtsspielen',
  at_home_games: 'An Heimspielen',
  at_practices: 'Bei Trainingseinheiten',
  audit_types: {
    canceled: 'Abgesagt',
    car_id: 'Fahrzeug',
    date: 'Datum',
    end_date: 'Ende',
    description: 'Beschreibung',
    name: 'Name',
    home: 'Heim',
    guest: 'Gast',
    status: 'Status',
    location: 'Ort',
    gym: 'Sporthalle',
    gym_address: 'Adresse',
    jerseys: 'Trikots',
    judge_team_id: 'Kampfgericht Mannschaft',
    judge_paper_id: 'Kampfgericht Person 1',
    judge_time_id: 'Kampfgericht Person 2',
    judge_24sec_id: 'Kampfgericht Person 3',
    judge_paper_asst_id: 'Kampfgericht Person 4',
    own_referee1: 'Schiedsrichter 1',
    own_referee2: 'Schiedsrichter 2',
    own_referee1_id: 'Schiedsrichter 1',
    own_referee2_id: 'Schiedsrichter 2',
    responsible_user_id: 'Verantwortliche Person',
    referee_1: 'Schiedrichter 1',
    referee_2: 'Schiedrichter 2',
    scheduled: 'Geplant',
    meet_at: 'Treffpunkt',
    meet_at_location: 'Treffpunkt Ort',
  },
  auto: 'Auto',
  available: 'Verfügbar',
  away_game: 'Auswärtsspiel',
  away_games: 'Auswärtsspiele',
  back: 'Zurück',
  back_to_login: 'Zurück zum Login',
  birthday: 'Geburtstag',
  calendar: 'Kalender',
  cancel: 'Abbrechen',
  cancellations: 'Absagen',
  canceled: 'Abgesagt',
  captain: 'Captain',
  cars: {
    singular: 'Fahrzeug',
    plural: 'Fahrzeuge',
    create: 'Fahrzeug hinzufügen',
    edit: 'Fahrzeug bearbeiten',
    delete: 'Fahrzeug löschen',
    carpool: 'Mitfahrgelegenheiten',
    drivers_licence: 'Führerscheinart',
    environment_badge: 'Umweltplakette',
    fuel: 'Kraftstoffart',
    licence_plate: 'Kennzeichen',
    reservable: 'Reservierbar',
    reservations: {
      title: 'Fahrzeugreservierungen',
      add: 'Fahrzeugreservierung erstellen',
      edit: 'Fahrzeugreservierung bearbeiten',
      delete: 'Fahrzeugreservierung löschen',
      external: 'Externe Reservierung',
      more: 'Weitere Fahrzeugreservierungen',
      more_info:
        'Entdecke weitere Fahrzeugreservierungen für dieses Fahrzeug einen Tag vor und nach diesem Spiel.',
      fields: {
        destination: 'Ziel',
      },
      time_range: {
        from: 'Ab {{time}}',
        to: 'Bis {{time}}',
        all_day: 'Ganztägig',
      },
    },
    game_info: {
      title: 'Fahrzeuginformationen',
      admin_popup: {
        description: 'Was möchtest du tun?',
        update: 'Fahrzeuge bearbeiten',
        view: 'Fahrzeugdetails anzeigen',
      },
    },
  },
  change_answer: 'Antwort ändern',
  changelog: 'Änderungshistorie',
  city: 'Stadt',
  close: 'Schließen',
  club: 'Verein',
  club_details: 'Vereinsdetails',
  club_games: 'Gesamtspielplan',
  club_settings: {
    functions: {
      title: 'Funktionen',
      items: {
        partners: {
          title: 'Partner',
          description:
            'Verwaltung von Partnern und Sponsoren inkl. Erstellung von Partner-Inhalten wie zb. Neuigkeiten oder Vorteile für Mitglieder.',
        },
      },
    },
  },
  clubs: 'Vereine',
  coach: 'Trainer',
  coaches: 'Trainer',
  coach_conflicts: 'Trainerkonflikte',
  coach_logging: 'Trainer Protokollierung',
  collapse: 'Einklappen',
  color: 'Farbe',
  comments: {
    singular: 'Kommentar',
    plural: 'Kommentare',
    number_of_comments_text_one: '{{count}} Kommentar verfügbar',
    number_of_comments_text_other: '{{count}} Kommentare verfügbar',
    last_comment_text: 'Neuester Kommentar von {{name}} am {{date}}',
    comment_as: 'Kommentieren als',
  },
  commitments: 'Zusagen',
  completed: 'Abgeschlossen',
  confirm: 'Bestätigen',
  contact: 'Kontakt',
  contacts: 'Kontakte',
  countdown: {
    days: 'Tage',
    hours: 'Stunden',
    minutes: 'Minuten',
    seconds: 'Sekunden',
  },
  country: 'Land',
  create_request: 'Anfrage erstellen',
  created_at: 'Erstellt am',
  crud: {
    image: {
      edit: 'Bearbeiten',
      upload: 'Hochladen',
    },
  },
  current_games: 'Aktuelle Spiele',
  custom_user_attributes: {
    title: 'Eigene Nutzerfelder',
    date: 'Datum',
    email: 'E-Mail',
    multi_email: 'E-Mail Liste',
    number: 'Nummer',
    sex: 'Geschlecht',
    text: 'Text',
  },
  dashboard: 'Dashboard',
  data_processing: {
    title: 'Auftragsverarbeitung',
    accepted_agreement_with_version:
      'Akzeptierter Auftragsverarbeitungsvertrag (Version {{version}})',
    accepted_agreements_singular:
      'Es wurde am {{date}} eine Vereinbarung zur Auftragsverarbeitung erfolgreich abgeschlossen.',
    accepted_agreements_plural:
      'Es wurde erstmalig am {{first}} und letztmalig am {{latest}} eine Vereinbarung zur Auftragsverarbeitung erfolgreich abgeschlossen.',
    agreement: 'Auftragsverarbeitungsvertrag',
    agreement_with_version:
      'Auftragsverarbeitungsvertrag (Version {{version}})',
    agree_disclamer_text:
      'Ich habe die Vereinbarung zur Auftragsverarbeitung gelesen.',
    agree_button: 'Vereinbarung abschließen',
    no_accepted_agreements:
      'Bitte schließe die Vereinbarung ab um Backcourt zu nutzen.',
  },
  date: 'Datum',
  default: 'Standard',
  delete: 'Löschen',
  delete_player: 'Spieler löschen',
  delete_players: 'Spieler löschen',
  delete_users: 'Mitglied(er) löschen',
  description: 'Beschreibung',
  deselect_all: 'Alle abwählen',
  details: 'Details',
  download_csv: 'CSV herunterladen',
  duplicate: 'Duplizieren',
  duration: 'Dauer',
  edit: 'Bearbeiten',
  edit_player: 'Spieler bearbeiten',
  edit_team: 'Mannschaft bearbeiten',
  edit_user: 'Mitglied bearbeiten',
  edited: 'Geändert',
  email: 'E-Mail Adresse',
  end: 'Ende',
  error: 'Fehler',
  event: 'Termin',
  event_type: 'Termintyp',
  event_types: {
    '0': 'Spiel',
    '1': 'Training',
  },
  event_roles: {
    '0': 'Spieler',
    '1': 'Trainer',
    '2': 'Schiedsrichter',
    '3': 'Hallenaufsicht',
    '4': 'Kampfgericht',
    '5': 'Trikots',
    '6': 'Eigene',
  },
  events: {
    singular: 'Termin',
    plural: 'Termine',
    details: 'Termindetails',
    events: {
      singular: 'Veranstaltung',
      plural: 'Veranstaltungen',
      add: 'Veranstaltung hinzufügen',
      canceled: 'Diese Veranstaltung wurde abgesagt.',
    },
  },
  expand: 'Aufklappen',
  feed: {
    basketball_game_comment: {
      header: 'hat einen Kommentar zum Spiel verfasst',
    },
    basketball_game_result: {
      title: 'Spielergebnis',
    },
    basketball_practice_comment: {
      header: 'hat einen Kommentar zum Training verfasst',
    },
    birthday: {
      header: 'feiert heute den {{number}}. Geburtstag',
      text: 'Herzlichen Glückwunsch zum Geburtstag!',
    },
    event_comment: {
      header: 'hat einen Kommentar zum Termin verfasst',
    },
    event_report: {
      header: 'hat einen Spielbericht erstellt',
    },
  },
  filter: 'Filter',
  filter_and_more: 'Filter und mehr',
  finished: 'Beendet',
  firstname: 'Vorname',
  from: 'Von',
  full_age: 'Volljährig',
  game: 'Spiel',
  gameday_planer: {
    title: 'Spieltagsplanung',
    current_week: 'Aktuelle KW',
    own_times: 'Eigene Zeiten',
    show_tasks: 'Aufgaben anzeigen',
    time_pending: 'Die Spielzeit wurde noch nicht festgelegt!',
  },
  game_details: 'Spieldetails',
  game_reports: {
    singular: 'Spielbericht',
    plural: 'Spielberichte',
    add: 'Spielbericht hinzufügen',
    edit: 'Spielbericht bearbeiten',
    delete: 'Spielbericht löschen',
    generate: {
      privacy: {
        title: 'Privatsphäre',
        description:
          'Unsere Software bietet Ihnen die Möglichkeit, Spielberichte mithilfe der OpenAI API generieren zu lassen. Dieses Feature ist vollständig optional und wird nur aktiviert, wenn Sie ausdrücklich zustimmen.',
        data_transfer:
          'Bei Nutzung des Spielbericht-Features werden die von Ihnen eingegebenen Texte und Informationen an die OpenAI API weitergeleitet. Dabei handelt es sich um einen Dienst der OpenAI, L.L.C., 3180 18th Street, San Francisco, CA 94110, USA. OpenAI verarbeitet diese Daten, um die gewünschten Spielberichte zu generieren. Die Daten können temporär in den USA gespeichert werden, wo möglicherweise kein gleichwertiger Datenschutz wie in der EU besteht.',
        consent:
          'Die Nutzung des Features und die Übermittlung der Daten erfolgt ausschließlich auf Basis Ihrer ausdrücklichen Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.',
        data_transfer_info:
          'Bitte beachten Sie, dass bei der Nutzung von OpenAI eine Datenübermittlung in ein Drittland erfolgt, in dem möglicherweise kein dem EU-Recht gleichwertiger Datenschutz gewährleistet ist.',
        voluntary:
          'Die Nutzung des Features ist freiwillig. Sie können das Feature jederzeit deaktivieren, indem Sie die entsprechende Funktion nicht nutzen.',
        more_info:
          'Weitere Informationen zur Datenverarbeitung durch OpenAI finden Sie in der Datenschutzerklärung von OpenAI: https://www.openai.com/privacy',
      },
      wizard: {
        title: 'Spielbericht generieren',
        steps: {
          game_details: {
            button_next: 'Weiter',
            final_score: 'Endstand',
            overtime: {
              title: 'Verlängerung',
              add: '+1 Verlängerung',
              remove: '-1 Verlängerung',
            },
            quarter: 'Viertel',
            special_events: 'Besondere Ereignisse',
            title: 'Spielinformationen',
          },
          general: {
            button_next: 'Weiter',
            info: 'Du kannst auch Felder in den kommenden Schritten leer lassen, wenn du sie nicht ausfüllen möchtest. Die Felder werden dann ignoriert.',
            privacy: {
              description:
                'Ich stimme der Übermittlung der von mir eingegebenen Daten an die OpenAI API zu, um einen Spielbericht zu generieren. Mir ist bekannt, dass die Verarbeitung durch OpenAI in den USA erfolgt und mögliche Datenschutzrisiken bestehen können.',
              link: 'Datenschutzbestimmungen',
            },
            public: {
              title: 'Öffentlich',
              description:
                'Öffentliche Spielberichte sind im Presse-Center für alle (auch externe Personen) sichtbar. Private Spielberichte sind nur für Vereinsmitglieder sichtbar.',
            },
            title: 'Allgemein',
            type: {
              title: 'Typ',
              pre: 'Vorbericht',
              post: 'Spielbericht',
            },
            writing_type: {
              neutral: 'Neutral',
              title: 'Schreibweise',
              description:
                'Der Schreibstil gibt an, ob der Bericht neutral oder für eine Mannschaft geschrieben wurde. Dies wird bei einem öffentlichen Bericht gekennzeichnet.',
            },
          },
          pregame: {
            button_next: 'Weiter',
            title: 'Vorbericht',
            additional_info: 'Zusätzliche Informationen',
          },
          preview: {
            button_next: 'Speichern',
            title: 'Vorschau',
            report_title: 'Titel',
            report_text: 'Text',
            loading: {
              '1': 'Der Sportjournalist hämmert gerade in die Tasten...',
              '2': 'Der Sportjournalist tippt eifrig auf der Tastatur...',
              '3': 'Der Sportjournalist ist tief in Gedanken versunken...',
              '4': 'Die Tasten der Tastatur glühen förmlich...',
              '5': 'Die Ideen sprudeln nur so hervor...',
              '6': 'Die Kreativität kennt keine Grenzen...',
              '7': 'Die Gedanken fliegen nur so über die Tastatur...',
            },
          },
          summary: {
            button_next: 'Generieren',
            title: 'Zusammenfassung',
            game_summary: 'Fazit zum Spiel',
            top_performer: {
              title: 'Top-Performer',
              description:
                'Welcher Spieler hat das Spiel besonders geprägt und warum? Stichworte genügen. Max. 200 Zeichen.',
            },
          },
        },
      },
    },
    manual: {
      title: 'Spielbericht verfassen',
      form: {
        public: {
          title: 'Öffentlich',
          description:
            'Öffentliche Spielberichte sind im Presse-Center für alle (auch externe Personen) sichtbar. Private Spielberichte sind nur für Vereinsmitglieder sichtbar.',
        },
        text: 'Text',
        title: 'Titel',
        type: {
          title: 'Typ',
          pre: 'Vorbericht',
          post: 'Spielbericht',
        },
        writing_type: {
          neutral: 'Neutral',
          title: 'Schreibweise',
          description:
            'Der Schreibstil gibt an, ob der Bericht neutral oder für eine Mannschaft geschrieben wurde. Dies wird bei einem öffentlichen Bericht gekennzeichnet.',
        },
      },
    },
    new_game_report_button: {
      cancel: 'Abbrechen',
      description: {
        question: 'Möchtest du einen Spielbericht verfassen oder generieren?',
        upgrade:
          'Upgrade jetzt auf das Bundesliga Paket um Spielberichte automatisch generieren zu lassen!',
      },
      generate: 'Generieren (Beta)',
      title: 'Spielbericht erstellen',
      write: 'Verfassen',
    },
    select_game: {
      title: 'Spiel auswählen',
      no_data: {
        title: 'Keine Spiele verfügbar',
        description:
          'Es wurden keine Spiele im Zeitraum von vor 3 Wochen bis in 3 Wochen gefunden.',
      },
    },
    type: {
      pre: 'Vorbericht',
      post: 'Spielbericht',
    },
    no_data: {
      title: 'Keine Spielberichte verfügbar',
      description: 'Es wurden noch keine Spielberichte verfasst.',
      description_admin_coach:
        'Es wurden noch keine Spielberichte verfasst. Füge jetzt einen Bericht über das Presse-Center hinzu.',
    },
  },
  games: {
    singular: 'Spiel',
    plural: 'Spiele',
    add: 'Spiel hinzufügen',
    add_team: '{{team}}-Spiel hinzufügen',
    canceled: 'Dieses Spiel wurde abgesagt.',
    edit: 'Spiel bearbeiten',
    delete: 'Spiel löschen',
    details: 'Spieldetails',
    number: 'Spielnummer',
    errors: {
      managed_by_association:
        'Dieses Spiel ist Teil einer Liga und wird vom Verband verwaltet',
      same_team: 'Bitte wähle unterschiedliche Mannschaften aus',
      select_active_coach_team:
        'Bitte wähle die aktive Mannschaft als Heim- oder Gastmannschaft',
    },
    form: {
      external_info:
        'Wähle zwei externe Mannschaften, wenn dieses Spiel ein externes Spiel ist. Dies ist der Fall, wenn interne Schiedsrichter für dieses Spiel angesetzt sind oder wenn das Spiel in einer eigenen Halle mit internem Kampfgericht stattfindet.',
      own_club_apponent: 'Interner Gegner',
    },
    other_games: {
      same_day: {
        title: 'Weitere Spiele an diesem Tag in der selben Halle',
        title_short: 'Tagesansicht',
        description:
          'Entdecke die übrigen Spiele an diesem Tag in dieser Halle.',
        navigate_info: {
          title: 'Spiel öffnen',
          description:
            'Möchtest du die Details dieses Spiels öffnen? Das aktuelle Detailansicht wird geschlossen.',
        },
      },
    },
  },
  general: 'Generell',
  generate: 'Generieren',
  go_to_web: 'Zur Web Version',
  guest: 'Gast',
  gym: 'Sporthalle',
  gyms: {
    singular: 'Sporthalle',
    plural: 'Sporthallen',
    add: 'Sporthalle hinzufügen',
    edit: 'Sporthalle bearbeiten',
    delete: 'Sporthalle löschen',
    address: 'Adresse der Halle',
    responsible_person_long: 'Hallenverantwortliche Person',
    responsible_person_short: 'Hallenverantwortung',
    color: {
      description: 'Die Farbe wird in den Kalenderansichten verwendet.',
    },
    closures: {
      title: 'Hallen-Sperrzeiten',
      add: 'Hallen-Sperrzeit hinzufügen',
      edit: 'Hallen-Sperrzeit bearbeiten',
      delete: 'Hallen-Sperrzeit löschen',
      affected: 'Betroffene Hallen: {{gyms}}',
      alert: {
        mobile: {
          info: 'Es kommt in den nächsten sieben Tagen zu Hallenschließungen. Tippe hier für aktuelle Informationen zu den betroffenen Hallen und den genauen Schließzeiten.',
        },
      },
      reason: 'Grund',
      practice_sync_info:
        'Vergiss nach dem Speichern nicht, die Trainingseinheiten zu synchronisieren, damit die Hallen-Sperrzeiten berücksichtigt werden. Du kannst die Synchronisierung in der Trainingsverwaltung durchführen.',
      vacations: {
        title: 'Ferien',
        sync: {
          title: 'Ferien synchronisieren',
          description:
            'Füge automatisch Hallen-Sperrzeiten für die Ferien deines Bundeslandes hinzu. Wähle ein Datum aus, bis zu dem die Ferien synchronisiert werden sollen. Du kannst nach der Auswahl des Datums die Daten noch bearbeiten, bevor sie gespeichert werden.',
        },
        description: 'Die Halle ist während dieser Zeit geschlossen.',
      },
    },
  },
  handicap: 'Beeinträchtigung(en)',
  help: 'Hilfe',
  helpouts: {
    title: 'Aushilfen',
    none: 'Keine Aushilfen',
    number_of_helpouts_one: 'Eine Aushilfe',
    number_of_helpouts_other: '{{count}} Aushilfen',
  },
  home: 'Heim',
  home_game: 'Heimspiel',
  home_games: 'Heimspiele',
  hygiene_concept: 'Hygienekonzept',
  iban: 'IBAN',
  image_upload_in_table_hint:
    'Bild kann nach dem Speichern direkt in der Tabelle hochgeladen werden.',
  import_users: 'Mitglieder importieren',
  important_information: 'Wichtige Information',
  in_min: 'in min',
  in_progress: 'In Bearbeitung',
  is_public: 'Ist öffentlich',
  incomplete: 'Unvollständig',
  interfaces: 'Schnittstellen',
  inventory: {
    singular: 'Inventar',
    plural: 'Inventar',
    add: 'Inventar hinzufügen',
    edit: 'Inventar bearbeiten',
    delete: 'Inventar löschen',
    categories: {
      singular: 'Kategorie',
      plural: 'Kategorien',
      add: 'Kategorie hinzufügen',
      edit: 'Kategorie bearbeiten',
      rename: 'Kategorie umbenennen',
      show: '{{name}} anzeigen',
      article_list: {
        not_found: 'Kateogrie nicht gefunden.',
        columns: {
          title: 'Titel',
          created_by: 'Erstellt von',
          created_at: 'Erstellt am',
        },
      },
      delete: {
        title: 'Kategorie löschen',
        description:
          'Wenn du eine Kategorie löschst, werden alle Objekte dieser Kategorie zur Kategorie "Unkategorisiert" verschoben. Vorhandene Unterkategorien rutschen in der Hierarchie eine Ebene nach oben. Bist du sicher, dass du die Kategorie löschen möchtest?',
      },
      navigation: {
        show_inventory: {
          title: 'Inventar anzeigen',
          description: {
            default: 'Alle {{number}} Objekte der Kategorie {{name}} anzeigen',
            uncategorized: 'Alle unkategorisierten Objekte anzeigen',
          },
        },
        subtitle:
          '{{numberOfSubcategories}} Unterkategorien | {{numberOfInventories}} Inventar-Objekte',
      },
      parentCategory: 'Übergeordnete Kategorie',
      uncategorized: 'Unkategorisiert',
    },
    details: {
      category: 'Kategorie',
      description: 'Beschreibung',
      name: 'Name',
      possessor: 'Besitzer',
      title: 'Inventardetails',
      status: 'Status',
      share_link: 'Übergabelink',
    },
    not_found: 'Inventar nicht gefunden',
    pool: {
      title: 'Vereinslager',
    },
    possessor: {
      title: 'Besitzer',
      you_info: 'Du bist der Besitzer dieses Inventars seit dem {{date}}',
    },
    transfers: {
      actions: {
        new: 'Übergabe starten',
      },
      attributes: {
        type: 'Typ',
        from_user: 'Von',
        to_user: 'An',
        comment: 'Kommentar',
        requested_at: 'Gestellt am',
        transferred_at: 'Übergeben am',
        due_date: 'Fällig am',
      },
      delete: {
        title: 'Übergabe löschen',
        description:
          'Möchtest du diese Übergabe wirklich löschen? Die Übergabe wird unwiderruflich gelöscht.',
      },
      receive: {
        description:
          'Bitte bestätige, dass du das Inventar erhalten hast und die Übergabe abschließen möchtest.',
        confirm: {
          title: 'Erhalt bestätigen',
          description:
            'Hast du das Inventar erhalten und willst die Übergabe abschließen?',
          success: 'Du bist nun Besitzer des Inventars.',
        },
      },
      return: {
        admin_request: {
          title: 'Rückgabe anfordern',
          description:
            'Du kannst die Rückgabe des Inventars anfordern. Der Besitzer des Inventars wird benachrichtigt und kann die Rückgabe bestätigen.',
          success:
            'Die Rückgabe wurde erfolgreich angefordert und der Besitzer benachrichtigt.',
        },
        confirm: {
          title: 'Rückgabe bestätigen',
          description:
            'Hast du das Inventar zurück erhalten und willst die Rückgabe bestätigen?',
          success:
            'Die Rückgabe wurde erfolgreich bestätigt. Das Inventar ist nun wieder im Vereinslager.',
        },
      },
      share: {
        create: {
          title: 'Übergabelink erstellen',
          description:
            'Erstelle einen Link, um das Inventar einem anderen Nutzer zu übergeben. ',
        },
        copy: {
          success: 'Der Link wurde in die Zwischenablage kopiert.',
        },
        receive: {
          title: 'Inventar übernehmen',
          description:
            'Möchtest du das Objekt {{name}} von der Person {{from}} übernehmen? Die Übergabe wird unwiderruflich bestätigt.',
          confirm: {
            button: 'Übernehmen',
            description:
              'Du hast das Inventar {{name}} von der Person {{from}} übernommen. Du findest das Objekt ab sofort in deiner Inventarliste.',
          },
        },
        show_link: 'Link anzeigen',
      },
      status: {
        pending: 'Offene Übergabe',
        transferred: 'In Besitz',
      },
      title: 'Übergabe',
      types: {
        transfer: 'Übergabe',
        pass: 'Weitergabe',
        return: 'Rückgabe',
      },
      history: 'Übergabehistorie',
    },
  },
  invite_users: 'Mitglieder einladen',
  invite_users_link: 'Einladungslinks',
  issues: {
    title: 'Konflikte',
    add: 'Konflikt hinzufügen',
    edit: 'Konflikt bearbeiten',
    delete: 'Konflikt löschen',
    details: 'Konfliktdetails',
    acknowledged: {
      yes: 'Bestätigt',
      no: 'Offen',
    },
    actions: {
      acknowledge: 'Als gesehen markieren',
      hide: 'Ausblenden',
      unhide: 'Wieder einblenden',
    },
    blocking: {
      yes: 'Blockierend',
      no: 'Nicht blockierend',
    },
    court_vision: {
      title: 'Court Vision (Beta)',
      beta: {
        title: 'Court Vision befindet sich in der Beta-Phase',
        description:
          'Court Vision ist deine neue Funktion, um Konflikte, fehlende Einteilungen und Auffälligkeiten in deinem Verein zu erkennen und zu lösen!',
        lines: {
          1: 'Die angezeigten Ergebnisse werden aktuell live berechnet, daher kann die Ladezeit ggf. etwas länger dauern. Bitte habe etwas Geduld.',
          2: 'In Zukunft werden wir die Berechnungen jede Nacht im Hintergrund durchführen, so dass ihr jeden Tag einen aktuellen Stand der Konflikte und Auffälligkeiten in eurem Verein habt.',
          3: 'Aktuell werden folgende Checks durchgeführt: Nutzerkonflikte aller Art, ausstehende Spielterminierung. In Zukunft kommen nach und nach weitere Checks hinzu.',
          4: 'Feedback bitte an mblum@backcourt-software.de - Vielen Dank für eure Mithilfe!',
        },
        show_more: {
          more: 'Mehr anzeigen',
          less: 'Weniger anzeigen',
        },
      },
      no_issues:
        'Coach T hat keine Auffälligkeiten gefunden. Alles in Ordnung!',
      load_error: 'Die Issues konnten nicht geladen werden.',
      retry: 'Erneut versuchen',
      hidden_filter_unavailable:
        'Ausgeblendete Issues können derzeit nicht separat geladen werden.',
      filters: {
        open: 'Offen',
        hidden: 'Ausgeblendet',
      },
      pagination: {
        load_more: {
          loading: 'Lädt...',
          idle: 'Mehr anzeigen',
        },
      },
      reload_button: {
        idle: 'Daten der kommenden 2 Wochen analysieren',
        loading: 'Daten werden analysiert...',
      },
      sections: {
        personal: 'Für mich',
        club: 'Verein',
      },
    },
    hidden: {
      yes: 'Versteckt',
      no: 'Sichtbar',
    },
    severity: {
      info: 'Info',
      warning: 'Warnung',
      error: 'Fehler',
    },
    status: {
      text: 'Status: {{status}}',
      types: {
        open: 'Offen',
        closed: 'Geschlossen',
      },
    },
    types: {
      basketball_event_gym_closed: 'Halle geschlossen',
      basketball_game_tbd: 'Spielterminierung ausstehend',
      person_single_event_conflict: 'Rollenkonflikt',
      person_multi_event_conflict: 'Terminüberschneidung',
      unknown: 'Unbekannter Konflikt',
    },
  },
  jersey_number: 'Trikotnummer',
  jerseys: 'Trikots',
  judge_team: 'Kampfgericht',
  judges: {
    auto_assignment: {
      title: 'Automatische Zuweisung',
      title_with_number: 'Automatische Zuweisung ({{number}} Personen)',
      question_number: 'Wie viele Personen werden pro Spiel benötigt?',
    },
    singular: 'Kampfgericht',
    team: 'Kampfgericht Mannschaft',
    paper: 'Kampfgericht Person 1',
    paper_asst: 'Kampfgericht Person 4',
    time: 'Kampfgericht Person 2',
    '24sec': 'Kampfgericht Person 3',
    suggestions: {
      '0': 'Spielt an diesem Tag in der selben Halle',
      '1': 'Kein Spiel an diesem Tag',
      '2': 'Heimspiel in einer anderen Halle',
      '3': 'Auswärtsspiel an diesem Tag',
      '4': 'Spielt zeitgleich',
      '5': 'Bestreitet dieses Spiel',
    },
  },
  keys: {
    singular: 'Schlüssel',
    plural: 'Schlüssel',
    add: 'Schlüssel hinzufügen',
    edit: 'Schlüssel bearbeiten',
    delete: 'Schlüssel löschen',
  },
  knowledge_base: {
    title: 'Wissensdatenbank',
    articles: {
      singular: 'Beitrag',
      plural: 'Beiträge',
      add: 'Beitrag hinzufügen',
      edit: 'Beiträge bearbeiten',
      form: {
        fields: {
          content: 'Inhalt',
        },
      },
      views_one: '{{count}} Aufruf',
      views_other: '{{count}} Aufrufe',
      detail_page: {
        attachments: {
          title: 'Anhänge',
          upload: {
            title: 'Anhang hochladen',
            description:
              'Ziehe eine Datei hierhin oder klicke, um eine Datei hochzuladen. Die Datei darf maximal 2 MB groß sein. Erlaubte Dateitypen: {{types}}',
          },
          delete: {
            description:
              'Möchtest du diesen Anhang wirklich löschen? Die Datei wird unwiderruflich gelöscht.',
          },
        },
        loading: 'Lädt...',
        loading_image: 'Lädt Bild...',
        created_by: 'Erstellt von {{name}} am {{date}} Uhr',
        not_found: 'Der Beitrag wurde nicht gefunden.',
      },
      errors: {
        no_data: {
          title: 'Keine Beiträge',
          description: 'Es wurden keine Beiträge gefunden',
        },
      },
      most_read: 'Meistgelesene Beiträge',
      empty: 'Keine Beiträge gefunden',
      latest: 'Neueste Beiträge',
      switch_category: {
        title: 'Kategorie wechseln',
        description: 'Wohin möchtest du die ausgewählten Beiträge verschieben?',
        select_category: 'Kategorie auswählen',
      },
    },
    categories: {
      singular: 'Kategorie',
      plural: 'Kategorien',
      add: 'Kategorie hinzufügen',
      rename: 'Kategorie umbenennen',
      show: '{{name}} anzeigen',
      article_list: {
        not_found: 'Kateogrie nicht gefunden.',
        columns: {
          title: 'Titel',
          created_by: 'Erstellt von',
          created_at: 'Erstellt am',
        },
      },
      delete: {
        title: 'Kategorie löschen',
        description:
          'Wenn du eine Kategorie löschst, werden alle Beiträge dieser Kategorie zur Kategorie "Unkategorisiert" verschoben. Vorhandene Unterkategorien rutschen in der Hierarchie eine Ebene nach oben. Bist du sicher, dass du die Kategorie löschen möchtest?',
      },
      uncategorized: 'Unkategorisiert',
    },
    menu: 'Menü',
    search: {
      title: 'Suche',
      question: 'Wonach suchst du?',
      description: 'Gib einen Suchbegriff ein oder durchsuche die Kategorien',
      placeholder: 'Suche...',
      results: {
        title: 'Suchergebnisse für "{{term}}"',
        more_relevant_results: 'Weitere relevante Ergebnisse',
        no_results:
          'Es konnten keine Ergebnisse für den Suchbegriff "{{searchText}}" gefunden werden.',
      },
    },
    tags: {
      singular: 'Tag',
      plural: 'Tags',
      add: 'Tag hinzufügen',
    },
  },
  lastname: 'Nachname',
  last_synced_at: 'Zuletzt synchronisiert am',
  last_updated: 'Zuletzt geändert',
  later: 'Später',
  leagues: {
    assistant: {
      check: {
        info: '{{number}} Spiele wurden gefunden. Bitte überprüfe ob alles passt, bevor du Speichern klickst.',
        title: 'Prüfen',
      },
      select_country: {
        title: 'Land auswählen',
        question: 'In welchem Land befindet sich die zu verknüfende Liga?',
        germany: 'Deutschland',
        switzerland: 'Schweiz (bald verfügbar)',
      },
      select_league: {
        age: 'Altersklasse',
        area: 'Gebiet',
        association: 'Verband',
        association_leagues: 'Verbandsligen',
        division: 'Spielklasse',
        enter_league_id: 'Liga ID eingeben...',
        league: 'Liga',
        league_id_info:
          'Die Liga ID findest du in der URL der Liga auf der basketball-bund.net Seite. Beispiel: https://www.basketball-bund.net/index.jsp?Action=102&liga_id=37239. Die Liga ID ist die Zahl hinter "liga_id=".',
        sex: 'Geschlecht',
        title: 'Liga auswählen',
        type: 'Ligatyp',
      },
      select_teams: {
        club_team: 'Vereinsmannschaft',
        league_team: 'Mannschaft der Liga',
        title: 'Mannschaften auswählen',
      },
      settings: {
        title: 'Einstellungen',
        own_referees:
          'Müssen die Schiedsrichter für die Spiele selbst gestellt werden? (Schiedsrichtereinteilungen werden nicht vom Verband verwaltet)',
      },
    },
    connect: 'Liga verknüpfen',
    sync: {
      title: 'Liga synchronisieren',
      question:
        'Möchtest du die Liga manuell synchronisieren? Je nach Liga kann dieser Vorgang einige Minuten dauern. Zudem werden die Daten 10 Minuten lang zwischengespeichert. In dieser Zeit werden weitere Synchronisierungen ignoriert. Du kannst in der Tabelle sehen, wann die Liga zuletzt synchronisiert wurde.',
      success:
        'Die Synchronisierung wurde erfolgreich zur Warteschlange hinzugefügt. Bitte warte einen Moment.',
    },
    no_data: {
      title: 'Keine Ligen gefunden',
      description: 'Es wurden keine dir zugeordneten Ligen gefunden.',
    },
    edit: 'Liga bearbeiten',
    delete: 'Liga löschen',
    plural: 'Ligen',
    singular: 'Liga',
  },
  legend: 'Legende',
  limit: 'Limit',
  linked_accounts: 'Verknüpfte Konten',
  linked_accounts_info:
    'Der Nutzer bekommt Zugriff zu den hier ausgewählten Nutzern.',
  list: 'Liste',
  loading: {
    title: 'Lädt...',
    additional_texts: {
      1: 'Wir pumpen gerade die Basketbälle auf...',
      2: 'Wir wischen den Hallenboden...',
      3: 'Wir tauschen die Netze aus...',
      4: 'Wir erstellen die Spielpläne...',
      5: 'Wir synchronisieren die Ligen...',
      6: 'Wir suchen die Schiedsrichter...',
      7: 'Wir suchen die Hallenaufsichten...',
      8: 'Wir suchen das Kampfgericht...',
      9: 'Wir suchen die Trikots...',
    },
  },
  location: 'Ort',
  login: 'Anmelden',
  login_now: 'Jetzt anmelden',
  logout: 'Abmelden',
  maintenance_mode: {
    title: 'Wartungsmodus',
    message:
      'Wir putzen gerade den Hallenboden und tauschen die Netze aus. Komme später wieder vorbei!',
    check_status: 'Status überprüfen',
    check_status_in: 'Status überprüfen (in {{number}} Sekunden)',
  },
  manage_notifications: 'Benachrichtigungen verwalten',
  manufacturer: 'Hersteller',
  mark_as_read: 'Als gelesen markieren',
  max_num_of_users: 'Max. Anzahl Nutzer',
  max_spectators: 'Max. Zuschauer',
  meet_at: 'Treffpunkt',
  meet_at_location: 'Treffpunkt Ort',
  members: 'Mitglieder',
  messages: {
    singular: 'Mitteilung',
    plural: 'Mitteilungen',
    create: 'Mitteilung erstellen',
    edit: 'Mitteilung bearbeiten',
    delete: 'Mitteilung löschen',
  },
  min_num_of_users: 'Min. Anzahl Nutzer',
  minutes: {
    long: 'Minuten',
    short: 'min',
  },
  more: 'Mehr',
  more_menu: {
    administration: {
      events: {
        description: 'Plane Veranstaltungen für deinen Verein',
      },
      inventory: {
        description:
          'Verwalte das Inventar deines Vereins und weise einzelne Objekte zu',
      },
      messages: {
        description:
          'Sende Nachrichten an Gruppen oder Mitglieder deines Vereins',
      },
      season: {
        description: 'Behalte den Überblick über die Spieltage deines Vereins',
      },
      tasks: {
        description: 'Verwalte Aufgaben für deinen Verein und weise sie zu',
      },
      teams: {
        description:
          'Erhalte einen Überblick über die Mannschaften deines Vereins',
      },
      users: {
        description: 'Mitgliederliste deines Vereins',
      },
    },
    my_club: {
      cars_reservations: {
        description:
          'Sieh auf einen Blick, welche Fahrzeuge wann genutzt werden und wer gerade unterwegs ist',
      },
      gym_closures: {
        description: 'Sehe wann die Hallen geschlossen sind',
      },
      knowledge_base: {
        description: 'Du suchst nach Informationen? Hier wirst du fündig!',
      },
      leagues: {
        description: 'Wie sieht es aktuell in den Ligen deines Vereins aus?',
      },
      partners: {
        description:
          'Entdecke exklusive Vorteile, Aktionen und generelle Informationen von Partnern deines Vereins',
      },
      press_center: {
        description: 'Werfe einen Blick auf die Spielberichte deines Vereins',
      },
      practice_times: {
        description: 'Ein Überblick über die Trainingszeiten deines Vereins',
      },
      schedule: {
        description: 'Alle Spiele deines Vereins auf einen Blick',
      },
      teams: {
        description: 'Alle Mannschaften deines Vereins auf einen Blick',
      },
    },
    my_team: {
      events: {
        description: 'Plane und verwalte die Termine deiner Mannschaft',
      },
      messages: {
        description: 'Sende Nachrichten an deine Mannschaft',
      },
      players: {
        description: 'Verwalte die Spieler deiner Mannschaft',
      },
      settings: {
        description: 'Verwalte die Einstellungen deiner Mannschaft',
      },
      tasks: {
        description:
          'Erstelle Mannschaftsaufgaben oder teile Vereinsaufgaben zu',
      },
    },
  },
  model: 'Modell',
  multiple_users: 'Mehrere Nutzer',
  my_assignments: 'Meine Zuteilungen',
  my_club: 'Mein Verein',
  my_events: 'Meine Termine',
  my_games: 'Meine Spiele',
  my_team: 'Meine Mannschaft',
  my_upcoming_events: {
    title: 'Meine kommenden Termine',
    no_data: {
      title: 'Keine kommenden Termine',
      description:
        'Keine Termine, keine Pflichten – die nächsten 14 Tage sind Offseason-Mode. 🏖️🏀',
    },
  },
  name: 'Name',
  nationality: 'Nationalität',
  new_message: 'Neue Mitteilung',
  never: 'Nie',
  next: 'Weiter',
  no: 'Nein',
  no_team: 'Keine Mannschaft',
  nominees: {
    all_players_nominated: 'Alle Spieler nominiert',
    info_text:
      'Hier kannst du die Spieler für den ausgewählten Termin nominieren. Wenn du keinen Spieler nominierst, werden alle Spieler (auch welche, die erst später zur Mannschaft hinzugefügt werden) automatisch nominiert.',
    nominate_players: 'Spieler nominieren',
    nominated: 'Nominiert',
    nominated_players: 'Nominierte Spieler',
    not_nominated: 'Nicht nominiert',
    number_of_nominated_players_one: 'Ein nominierter Spieler',
    number_of_nominated_players_other: '{{count}} nominierte Spieler',
    user_not_nominated:
      'Der ausgewählte Spieler wurde für diesen Termin nicht nominiert.',
  },
  note: 'Notiz',
  notifications: {
    singular: 'Benachrichtigung',
    plural: 'Benachrichtigungen',
    new: 'Neue Benachrichtigung',
    new_categories: {
      title: 'Neue Benachrichtigungskategorien',
      message:
        'Wir haben unsere Benachrichtigungskategorien aktualisiert! Bitte überprüfe deine Einstellungen, ob alle gewünschten Benachrichtigungen aktiviert sind. Bitte klicke auf "Speichern", auch wenn du keine Änderungen vorgenommen hast.',
      action: 'Zu den Einstellungen',
    },
    /** Types */
    admin: 'Administrator',
    all: 'Alle',
    assignments: 'Einteilungen',
    basketball: 'Basketball',
    birthdays: 'Geburtstage',
    coaches: 'Trainer',
    comments: 'Kommentare',
    events: 'Veranstaltungen',
    event_reply: 'Zu-/Absagen',
    game_sync: 'Ligen Synchronisierung (Spielliste)',
    games: 'Spiele',
    general: 'Generell',
    inventories: 'Inventar',
    jerseys: 'Trikots',
    judges: 'Kampfgericht',
    messages: 'Mitteilungen',
    players: 'Spieler',
    practices: 'Trainingseinheiten',
    prospects: 'Interessenten',
    referee: 'Schiedsrichter',
    referees: 'Schiedsrichter',
    reminders: 'Erinnerungen',
    switch_requests: 'Wechselanfragen',
    switches: 'Wechselanfragen',
    tasks: 'Aufgaben',
    team: 'Mannschaft',
    team_assignment: 'Mannschaftszuweisung',
    team_assigned: 'Mannschaftszuweisungen',
    team_tasks: 'Aufgaben',
    user_registration: 'Nutzerregistrierung',
    users: 'Nutzer',
    /** Questions */
    questions: {
      delete_all: 'Alle Benachrichtiungen löschen?',
      mark_all: 'Alle Benachrichtungen als gelesen markieren?',
    },
  },
  number: 'Nummer',
  number_of_seats: 'Anzahl Sitzplätze',
  ok: 'Ok',
  operations_center: {
    title: 'Spielbetrieb-Zentrale',
    open_task: {
      singular: 'Offene Aufgabe',
      plural: 'Offene Aufgaben',
      messages: {
        no_team_assigned:
          'Der Aufgabe {{task}} ist keine Mannschaft zugewiesen.',
        not_fully_assigned:
          'Es müssen noch {{number}} Personen der Aufgabe {{task}} zugewiesen werden.',
      },
    },
    conflict: {
      singular: 'Konflikt',
      plural: 'Konflikte',
      messages: {
        overlapping: 'Die Person {{name}} hat Überschneidungen!',
      },
      roles: {
        coach: 'Trainer',
        player: 'Spieler',
        referee: 'Schiedsrichter',
      },
    },
  },
  opponent: 'Gegner',
  owners: {
    singular: 'Besitzer',
    plural: 'Besitzer',
    add: 'Besitzer hinzufügen',
    edit: 'Besitzer bearbeiten',
    delete: 'Besitzer löschen',
  },
  own_column_arrangements: 'Eigene Spaltenanordnungen',
  own_guest_team: 'Eigene Gastmannschaft',
  own_home_team: 'Eigene Heimannschaft',
  own_referee1: 'Schiedsrichter 1',
  own_referee2: 'Schiedsrichter 2',
  own_referees: 'Eigene Schiedsrichter',
  own_reply: 'Eigene Zusage',
  parent_accounts: 'Eltern Konten',
  parking: 'Parkplatz',
  participants: {
    singular: 'Teilnehmer',
    plural: 'Teilnehmer',
  },
  partners: {
    singular: 'Partner',
    plural: 'Partner',
    add: 'Partner hinzufügen',
    edit: 'Partner bearbeiten',
    delete: 'Partner löschen',
    form: {
      fields: {
        address: 'Adresse',
        category: 'Kategorie',
        name: 'Name',
        description: 'Beschreibung',
        url: 'Internetseite',
        street: 'Straße',
        zip_code: 'PLZ',
        city: 'Ort',
        image: 'Logo',
        sort_order: 'Sortierreihenfolge',
      },
      info: {
        category:
          "Kategorie-Zusatz zum Namen des Partners (z.B. 'Hauptsponsor')",
        sort_order:
          'Je höher die Zahl, desto weiter oben wird der Partner angezeigt. Keine Zahl = Standardsortierung nach Name.',
      },
    },
    sections: {
      singular: 'Sektion',
      plural: 'Sektionen',
      add: 'Sektion hinzufügen',
      edit: 'Sektion bearbeiten',
      delete: 'Sektion löschen',
      valid_until: 'Gültig bis',
      valid_from: 'Ab',
      expired: 'abgelaufen',
      form: {
        fields: {
          title: 'Titel',
          body: 'Beschreibung',
          sort_order: 'Sortierreihenfolge',
          active: 'Aktiv',
          starts_at: 'Gültig ab',
          ends_at: 'Gültig bis',
          type: {
            title: 'Typ',
            enum: {
              text: 'Text',
              coupon: 'Gutschein',
              news: 'Neuigkeiten',
            },
          },
          image: 'Bild',
        },
      },
    },
  },
  past_games: {
    show: 'Vergangene Spiele anzeigen',
    hide: 'Vergangene Spiele ausblenden',
  },
  pending: 'Ausstehend',
  passive: 'Passiv',
  passive_member: 'Passivmitglied',
  password: 'Passwort',
  password_confirmation: 'Passwort bestätigen',
  person: 'Person',
  phone: 'Telefonnummer',
  player: 'Spieler',
  players: 'Spieler',
  possible_events: 'Mögliche Termine',
  practice: 'Training',
  practice_time: {
    add: 'Trainingszeit hinzufügen',
    edit: 'Trainingszeit bearbeiten',
    split_gym: {
      title: 'Geteilte Halle',
      description:
        'Die Halle wird in mehrere Teile geteilt. Die Mannschaften trainieren gleichzeitig in verschiedenen Hallenteilen.',
    },
  },
  practice_times: 'Trainingszeiten',
  practices: {
    singular: 'Trainingseinheit',
    singular_short: 'Training',
    plural: 'Trainingseinheiten',
    add: 'Trainingseinheit hinzufügen',
    add_plural: 'Trainingseinheiten hinzufügen',
    add_multi_via_web:
      'Mehrere Trainingseinheiten und Trainings-Serien können über die Web Version hinzugefügt werden.',
    canceled: 'Dieses Training wurde abgesagt.',
    edit: 'Trainingseinheit bearbeiten',
    edit_plural: 'Trainingseinheiten bearbeiten',
    delete: 'Trainingseinheit löschen',
    administration: {
      title: 'Trainingsverwaltung',
      practice_times: {
        title: 'Trainingszeiten',
        calendar: {
          title: 'Wochenansicht',
        },
        new_feature_info:
          'Die Trainingszeiten werden ab sofort in der Trainingsverwaltung verwaltet. Du findest die Funktion unter Saison > Trainingsverwaltung.',
        iframe: {
          feature_info:
            'Du kannst die Übersicht der Trainingszeiten auch auf deiner Homepage einbinden. Kopiere dazu den iFrame Code und füge ihn auf deiner Homepage ein.',
          title: 'iFrame',
          description: 'Füge diesen iFrame Code auf deiner Homepage ein.',
          link: {
            title: 'Link',
          },
        },
        schedules: {
          title: 'Trainingspläne',
          add: 'Trainingsplan hinzufügen',
          duplicate: 'Trainingsplan duplizieren',
          edit: 'Trainingsplan bearbeiten',
          active: {
            description:
              'Soll dieser Plan vorerst nur ein Entwurf sein? Erst nach Aktivierung hat der Plan Auswirkungen auf die Generierung von Trainingseinheiten.',
          },
          active_from_till: {
            from_till: 'Aktiv ab {{from}} bis {{till}}',
            from: 'Aktiv ab {{from}}',
            till: 'Aktiv bis {{till}}',
          },
          current: {
            title: 'Aktueller Trainingsplan: {{name}}',
          },
          mark_as_default: {
            title: 'Als Standard markieren',
            description:
              'Der Standardplan wird automatisch an Tagen verwendet, für die kein spezifischer Trainingsplan festgelegt wurde.',
          },
          upcoming: {
            more: 'Später anstehende Trainingspläne',
            title: 'Anstehender Trainingsplan: {{name}}',
          },
        },
      },
      tour: {
        one: {
          title: 'Neue Trainingsverwaltung',
          description:
            'Willkommen bei der neuen Trainingsverwaltung. Es ist nun möglich, mehrere Trainingspläne zu erstellen, die automatisch je nach definiertem Zeitraum gelten. Zudem kannst du hier neue Trainingspläne anlegen oder bestehende Pläne duplizieren.',
        },
        two: {
          title: 'Übersicht und Verwaltung der Trainingspläne',
          description:
            'In der Übersicht siehst du, welcher Trainingsplan für welchen Zeitraum gilt.',
        },
        three: {
          title: 'Verwaltung der Trainingszeiten',
          description:
            'Hier kannst du die Trainingszeiten deiner Mannschaften verwalten. Du hast die Möglichkeit, neue Trainingszeiten anzulegen sowie bestehende zu bearbeiten oder zu löschen.',
        },
        four: {
          title: 'Wechseln zwischen Trainingsplänen',
          description:
            'Über das Dropdown-Menü kannst du zwischen den verschiedenen Trainingsplänen wechseln.',
        },
        five: {
          title: 'Trainingseinheiten generieren',
          description:
            'Nachdem du deinen Plan erstellt oder angepasst hast, kannst du über diesen Button alle Trainingseinheiten automatisch generieren oder aktualisieren lassen. Beachte, dass unter „Verwaltung > Mannschaften“ bei jeder Mannschaft ein „Synchronisieren bis“-Datum hinterlegt werden kann. Die Trainingseinheiten werden dann bis zu diesem Datum synchronisiert.',
        },
      },
    },
    sync: {
      title: 'Trainingseinheiten synchronisieren',
      until: 'Trainingseinheiten synchronisieren bis',
      admin: {
        info: 'Hier kann die automatische Synchronisierung der Trainingseinheiten gesteuert werden. Die Trainingseinheiten werden automatisch bis zum ausgewählten Datum synchronisiert. Falls das neu ausgewählte Datum früher ist, als das Datum einer gewählten Mannschaft, werden alle zuvor synchronisierten/generierten Trainingseinheiten, welche nach dem ausgewählten Datum liegen, gelöscht. Die Synchronisierung kann in der Trainingsverwaltung durchgeführt werden.',
      },
      status: {
        until:
          'Trainingseinheiten werden automatisch bis zum {{date}} synchronisiert.',
        no_sync:
          'Trainingseinheiten werden aktuell nicht automatisch synchronisiert.',
      },
      icon: {
        tooltip: 'Automatisch generierte Trainingseinheit',
      },
      info: 'Möchtest du die Trainingseinheiten deines Vereins synchronisieren? Alle Trainingseinheiten werden auf Grundlage der Trainingspläne für jede Mannschaft bis zum eingestellten Datum (Verwaltung > Mannschaften) synchronisiert. Manuell angelegte Trainingseinheiten bleiben unberührt.',
    },
    details: 'Trainingsdetails',
    link: 'Trainingseinheiten verknüpfen',
    link_info:
      'Mit dieser Funktion werden alle allgemeinen Trainingseinheiten bis zum gewählten Datum automatisch hinzugefügt und synchronisiert. Vorteil: Bei genereller Änderung des Trainingsortes, des Wochentags oder der Uhrzeit durch den Administrator werden alle Termine automatisch aktualisiert. Hinweis: Der Administrator muss die Trainingszeiten im System hinterlegt haben, damit Trainingseinheiten hinzugefügt werden können. Achtung: Bereits gelöschte verknpüfte Trainingseinheiten werden nach erneuter Ausführung dieser Funktion wieder hinzugefügt! Zudem werden alle verknpüften Trainingseinheiten, die nach dem gewählten Datum liegen, gelöscht.',
    errors: {
      select_active_coach_team: 'Die aktive Mannschaft muss ausgewählt sein',
    },
    other_practices: {
      same_day: {
        title: 'Tagesansicht',
        description:
          'Entdecke die übrigen Trainingseinheiten anderer Mannschaften an diesem Tag in dieser Halle.',
      },
    },
  },
  press_center: {
    title: 'Pressebereich',
    settings: {
      title: 'Pressesbereich',
      feature_info:
        'Binde den Pressebereich auf deiner Homepage ein und informiere die Presse und weitere Interessierte über die neuesten Spielberichte deines Vereins.',
      link: {
        title: 'Link',
      },
      iframe: {
        title: 'iFrame',
        description: 'Füge diesen iFrame Code auf deiner Homepage ein.',
      },
    },
    details: {
      created_by: 'Erstellt von {{name}} am {{date}} Uhr',
    },
  },
  prev: 'Zurück',
  preview: 'Vorschau',
  print: 'Drucken',
  privacy: 'Datenschutz',
  private_cars: 'Privatautos',
  profile: 'Profil',
  prospects: {
    singular: 'Interessent',
    plural: 'Interessenten',
    add: 'Interessent hinzufügen',
    edit: 'Interessent bearbeiten',
    delete: 'Interessent löschen',
    experience: {
      title: 'Erfahrung',
      none: 'Keine',
      low: 'Anfänger',
      medium: 'Fortgeschritten',
      high: 'Profi',
    },
    info: {
      delete:
        'Möchtest du diesen Interessenten wirklich löschen? Wenn der Status "Ausstehend" oder "Warteliste" ist, wird dem Interessenten eine E-Mail mit einer Absage gesendet.',
      teams:
        'Hier kannst du den Interessenten einer oder mehreren Mannschaften zuweisen. Trainer der ausgewählten Mannschaften werden automatisch benachrichtigt und können den Interessenten annehmen, auf die Warteliste setzen oder ablehnen.',
      text: 'Hier werden alle Interessenten aufgelistet, welche sich über das Kontaktformular auf der Homepage deines Vereins gemeldet haben. Du kannst die Interessenten annehmen, auf die Warteliste setzen oder ablehnen. Wenn du eine dieser Aktionen ausführst, wird der Interessent automatisch per E-Mail benachrichtigt. Im Falle einer Zusage enthält die E-Mail Information über die Trainingszeiten deiner Mannschaft. Zusätzlich kannst du noch eine persönliche Nachricht an den Interessenten hinzufügen.',
      reply: {
        approved:
          'Annehmen: Der Interessent bekommt eine Zusage per E-Mail mit den Trainingszeiten der ausgewählten Mannschaft.',
        declined:
          'Ablehnen: Der Interessent bekommt eine Absage per E-Mail, mit der Info, dass er sich nächste Saison nochmals melden kann.',
        waitlist:
          'Warteliste: Der Interessent bekommt eine E-Mail mit der Info, dass alle Mannschaften ausgelastet sind, er aber auf der Warteliste steht. Sobald ein Platz frei wird, kann die Anfrage erneut mit "Annehmen" beantwortet werden.',
        description:
          'Hier kannst du auf die Anfrage antworten. Wenn du eine Nachricht hinzufügst, wird diese dem Interessenten der Standard E-Mail angehängt. Achtung: Wenn du bereits geantwortet hast wird trotzdem eine neue E-Mail mit der aktualisierten Antwort versendet. Die Standard E-Mail enthält folgenden Inhalt:',
      },
    },
    message: 'Nachricht',
    replies: {
      singular: 'Antwort',
      approve: 'Annehmen',
      decline: 'Ablehnen',
      waitlist: 'Warteliste',
      previous: {
        title: 'Vorherige Antworten',
        text: 'Antwort vom {{date}}',
        replied_by: 'Antwort von {{name}}',
      },
      reply: 'Antworten',
    },
    sign: {
      title: 'Interessent anmelden',
      description:
        'Möchtest du den Interessenten als Mitglied bei Backcourt anmelden? Der Interessent wird automatisch als Mitglied angelegt und erhält eine E-Mail mit den Zugangsdaten. Zudem wird er automatisch zu den ausgewählten Mannschaften hinzugefügt.',
    },
    settings: {
      title: 'Interessenten',
      feature_info:
        'Die Interessenten-Funktion ermöglicht es dir, Interessenten zu verwalten und diese bei Bedarf als Mitglied anzumelden. Alles was du tun musst, ist das Kontaktformular via Link oder iFrame auf deiner Homepage einzubinden. Die Interessenten werden dann automatisch in Backcourt angelegt und du kannst sie hier verwalten. Wenn du bei deinen Mannschaften das Geschlecht und die Altersklasse hinterlegt hast, werden die Interessenten automatisch der passenden Mannschaft zugeordnet (vorausgesetzt es gibt nur einen Treffer). Admins (und ggf. Trainer) erhalten dann automatisch eine Benachrichtigung, dass sich eine Person über das Kontaktformular gemeldet hat. Die Interessenten werden automatisch per E-Mail benachrichtigt, wenn du sie auf die Warteliste setzt, ablehnst oder annimmst. Bei einer Zusage wird die E-Mail mit den Trainingszeiten deiner Mannschaft automatisch angehängt.',
      iframe: {
        title: 'iFrame',
        description: 'Füge diesen iFrame Code auf deiner Homepage ein.',
      },
      link: {
        title: 'Link',
      },
    },
    status: {
      title: 'Status',
      pending: 'Ausstehend',
      approved: 'Angenommen',
      declined: 'Abgelehnt',
      waitlist: 'Warteliste',
      signed: 'Angemeldet',
    },
  },
  push: 'Push',
  reason: 'Grund',
  recipients: 'Empfänger',
  referees: {
    singular: 'Schiedsrichter',
    plural: 'Schiedsrichter',
    referee_1: 'Schiedsrichter 1',
    referee_2: 'Schiedsrichter 2',
    referee_bill: 'Schiedsrichterabrechnung',
    assign_me: {
      title: 'Mich zuweisen',
      description:
        'Möchtest du dich selbst als Schiedsrichter eintragen? Wenn ja, bedenke bitte, dass dies verbindlich ist. Du kannst jedoch eine Wechselanfrage stellen, wenn du dich später abmelden möchtest. Dein Eintrag bleibt bestehen, bis ein anderer Schiedsrichter deine Zuweisung übernimmt.',
    },
  },
  refresh: 'Aktualisieren',
  refresh_page: 'Seite aktualisieren',
  registration: {
    title: 'Registrierung',
    subtitle:
      'Hallo! Der Verein {{name}} möchte, dass du der Spielbetriebsverwaltung Backcourt beitrittst. Als Mitglied hast du Zugriff auf all deine Termine!',
    subtitle_team:
      'Du wirst nach der Registrierung direkt der Mannschaft {{name}} hinzugefügt.',
    link_accounts_info:
      'Bitte beachten: E-Mail Adresse und Passwort dienen als Login! Daher kann jede Mail-Adresse nur einmalig verwendet werden. Eltern können (falls das Kind/die Kinder noch keine eigenen E-Mail Adressen besitzen) ihre Daten angeben und bei der Vereinsverwaltung Konten für die Kinder ohne E-Mail Adressen beantragen. Die Kinderkonten werden dann von der Vereinsverwaltung mit dem Elternkonto verknüpft.',
  },
  registration_status: 'Registrierungsstatus',
  replies: 'Antworten',
  represented_by: 'Erziehungsberechtigte Person',
  request_password: 'Password anfordern',
  reset: 'Zurücksetzen',
  reset_password: 'Passwort zurücksetzen',
  result_reporting: 'Ergebnismeldung',
  roles: {
    role: 'Rolle',
    roles: 'Rollen',
    admin: 'Administrator',
    bb_admin: 'Administrator',
    bb_coach: 'Trainer',
    bb_referee: 'Schiedsrichter',
    bb_user: 'Nutzer',
    vehicle_admin: 'Fuhrpark-Administrator',
  },
  row: 'Zeile',
  save: 'Speichern',
  save_column_selection: 'Spaltenauswahl speichern',
  schedule: 'Spielplan',
  scheduled: 'Geplant',
  scrimmage_game: 'Testspiel',
  scrimmage_games: 'Testspiele',
  search: 'Suchen',
  search_player: 'Spieler suchen',
  season: 'Saison',
  season_planer: {
    title: 'Saisonplaner',
    gym_closures: {
      title: 'Hallen gesperrt!',
      description: 'Folgende Hallen sind am diesen Tag gesperrt: {{gyms}}',
    },
  },
  seats: 'Sitzplätze',
  seats_available: 'Sitzplätze verfügbar',
  select: 'Wählen',
  select_all: 'Alle auswählen',
  select_columns: 'Spalten auswählen',
  select_date: 'Datum wählen',
  select_game: 'Spiel wählen',
  select_location: 'Ort wählen',
  select_player: 'Spieler wählen',
  select_recipients: 'Empfänger wählen',
  select_team: 'Mannschaft wählen',
  select_user: 'Nutzer wählen',
  select_users: 'Nutzer wählen',
  select_widget: 'Widget wählen',
  selected: 'Ausgewählt',
  semicolon: 'Semikolon',
  send: 'Senden',
  send_welcome_mail: 'Willkommens-Mail verschicken',
  sender: 'Absender',
  settings: {
    title: 'Einstellungen',
    interfaces: {
      ical: {
        title: 'iCal Kalender',
        settings: {
          own_games: 'Eigene Spiele',
          own_practices: 'Eigene Trainingseinheiten',
          own_tasks: 'Eigene Aufgaben',
          own_referee_games: 'Eigene Schiedsrichteransetzungen',
          hide_cancellations: 'Abgesagte Termine ausblenden',
          additional_teams: 'Weitere Mannschaftsspielpläne',
        },
      },
    },
    user: {
      privacy: {
        display_name_on_team_page: {
          title: 'Name anzeigen',
          description:
            'Den eigenen Namen auf der Mannschaftsseite für andere Mitglieder anzeigen',
        },
      },
      child_events: {
        title: 'Termine von verknüpften Konten',
        description:
          'Termine von verknüpften Konten bei den eigenen Terminen anzeigen',
      },
      avatar: {
        update: 'Profilfoto ändern',
        delete: 'Profilfoto löschen',
      },
      init_app_screen: {
        title: 'Termine bei App Start anzeigen',
        description:
          'Wenn die App gestartet wird, werden direkt deine Termine anstatt des "Demnächst" Bildschirms angezeigt.',
      },
    },
  },
  sex: {
    title: 'Geschlecht',
    male: 'Männlich',
    female: 'Weiblich',
    diverse: 'Divers',
  },
  show_all: 'Alle anzeigen',
  shuffle: 'Mischen',
  smart_assistant: {
    intro: {
      text: 'Solly {{name}}! ich bin Coach T, dein zukünftiger Assistent für die Spielbetriebsverwaltung. Ab sofort helfe ich dir bei der Analyse deiner Vereinsdaten wie zb. bei Konflikten deiner Mitglieder! Schau dir doch mal die Court Vision Funktion an. Viel Spaß!',
    },
  },
  sorting: 'Sortierung',
  standings: 'Tabelle',
  statistics: {
    plural: 'Statistiken',
    date_range: {
      title: 'Zeitraum',
    },
    games: {
      title: 'Spiele',
    },
    practices: {
      title: 'Trainingseinheiten',
    },
    tasks: {
      title: 'Aufgaben',
    },
    users: {
      title: 'Nutzer',
    },
  },
  status: 'Status',
  street: 'Straße',
  subject: 'Betreff',
  subscriptions: {
    active_subscriptions: 'Aktive Abonnements',
    billing_portal: 'Rechnungsportal & Kündigung',
    full_features: {
      info: 'Eine Übersicht über den Funktionsumfang der Produkte findest du hier:',
      link: 'Produktseite',
    },
    includes: 'Beinhaltet unter anderem',
    no_subscription: {
      info: 'Es wurde bisher kein Abonnement abgeschlossen. Wähle unten ein Abonnement aus und starte den Bezahlvorgang über unseren Zahlungsdienstleister Stripe.',
    },
    price: {
      per_year: '{{amount}} €/Jahr',
      per_month: '{{amount}} €/Monat',
    },
    subscribe: 'Abonnieren',
    change_subscription: {
      checkbox_text: 'Ich habe die AGB gelesen und akzeptiere diese.',
      confirm_button: 'Abonnement zahlungspflichtig aktualisieren',
      downgrade: {
        pending_title: 'Ausstehendes Paket-Downgrade',
        info: 'Du kannst noch bis zum {{date}} das Downgrade über den Button unten stornieren. Nach der Stornierung läuft dein aktuelles Paket weiter und du kannst gegebenenfalls wieder zu einem anderen Paket wechseln.',
        button: 'Downgrade stornieren',
        button_tooltip: 'Bist du sicher?',
      },
      info_with_restrictions:
        'Du kannst über "Rechnungsportal & Kündigung" jederzeit dein Paket kündigen oder Rechnungen einsehen. Unter diesem Text kannst du einen Wechsel zu einem anderen Produkt durchführen. Ein Upgrade ist jederzeit möglich. Ein Downgrade wird zum Ende der aktuellen Laufzeit durchgeführt. Zudem ist ein Downgrade nur möglich, wenn du die Datenlimits des jeweiligen Pakets nicht überschritten hast. Die Kündigung ist zum Ende der Laufzeit möglich, beachte jedoch, dass Daten, die über dem Freien Limit liegen, nach der Kündigung ggf. gelöscht werden. Bei Fragen stehen wir dir gerne zur Verfügung.',
      info_without_restrictions:
        'Du kannst über "Rechnungsportal & Kündigung" jederzeit dein Paket kündigen oder Rechnungen einsehen. Unter diesem Text kannst du einen Wechsel zu einem anderen Produkt durchführen. Ein Upgrade ist jederzeit möglich. Ein Downgrade wird zum Ende der aktuellen Laufzeit durchgeführt. Zudem ist ein Downgrade nur möglich, wenn du die Datenlimits des jeweiligen Pakets nicht überschritten hast. Die Kündigung ist zum Ende der Laufzeit möglich, beachte jedoch, dass Daten, die über dem Freien Limit liegen, nach der Kündigung ggf. gelöscht werden. Bei Fragen stehen wir dir gerne zur Verfügung.',
      invoice_preview: {
        title: 'Aktualisierung bestätigen',
        card_info:
          'Es wird die aktuell hinterlegte Zahlungsmethode verwendet. Falls du eine andere Zahlungsmethode verwenden möchtest, ändere diese bitte vor der Aktualisierung im Rechnungsportal.',
        calculation: {
          info: 'Setzt sich zusammen aus',
          credit: 'Verrechnete Gutschrift von {{product}}',
          charge: 'Verrechnete Gebühr für {{product}}',
        },
        general_info:
          'Hier siehst du eine Übersicht, wie sich der Paketwechsel auf deine Rechnungen auswirkt.',
        due: {
          afterwards: {
            month: 'Welcher Betrag ab {{date}} monatlich fällig wird',
            year: 'Welcher Betrag ab {{date}} jährlich fällig wird',
          },
          next: {
            today: 'Heute fällig',
            date: 'Am {{date}} fällig',
          },
        },
        type_info: {
          switch: 'Dein Wechsel wird sofort durchgeführt.',
          switch_immidiate:
            'Dein Paket-Upgrade wird sofort durchgeführt und du kommst direkt in den Genuss der neuen Funktionen.',
          switch_next_period:
            'Dein Paket-Downgrade wird zum Ende der aktuellen Laufzeit durchgeführt. Bis dahin kannst du noch alle Funktionen deines aktuellen Pakets nutzen. Bitte beachte, dass du nach dem Downgrade ggf. Daten unwiderruflich verlierst, die über dem Limit des gewählten Pakets liegen.',
        },
      },
      too_many: 'Du hast zu viele {{type}} angelegt ({{count}}).',
      button_type: {
        upgrade: 'Upgrade',
        downgrade: 'Downgrade',
        active: 'Aktiv',
        switch: 'Wechseln',
        switch_immidiate: 'Sofort wechseln',
        switch_next_period: 'Zum Ende der aktuellen Laufzeit wechseln',
        not_allowed: 'Nicht erlaubt',
      },
      success: {
        message: {
          switch_immidiate:
            'Danke für dein Vertrauen. Dein Paket wurde erfolgreich geändert. Du kannst nun sofort alle Funktionen des gebuchten Pakets nutzen! Viel Spaß! 🏀',
          switch_next_period:
            'Dein Paket-Downgrade wird zum Ende der aktuellen Laufzeit durchgeführt. Bitte beachte, dass du nach dem Downgrade ggf. Daten unwiderruflich verlierst, die über dem Limit des gewählten Pakets liegen.',
        },
      },
    },
    title: 'Abonnements',
    trial: {
      title: 'Aktiver Testzeitraum',
      info: 'Du genießt noch bis zum {{date}} alle Funktionen des Bundesliga-Pakets. Nach der Testphase wird automatisch das Freiplatz-Paket aktiv. Du kannst jederzeit ein Upgrade durchführen.',
    },
    kreisliga: {
      title: 'Kreisliga',
    },
    regionalliga: {
      title: 'Regionalliga',
    },
    bundesliga: {
      title: 'Bundesliga',
    },
  },
  switch_account: 'Nutzer wechseln',
  switch_requests: {
    singular: 'Wechselanfrage',
    plural: 'Wechselanfragen',
    create_info_text:
      'Keine Wechselanfragen vorhanden. Du kannst über den + Button oben rechts eine neue erstellen!',
  },
  switch_team: 'Mannschaft wechseln',
  tab: 'Tab',
  table: {
    pagination: {
      total: '{{from}}-{{to}} von {{total}} Einträgen',
    },
  },
  tan: 'TA-Nummer',
  take_over: 'Übernehmen',
  taken_over_by: 'Übernommen von {{name}}',
  tasks: {
    assignment: 'Aufgabenzuweisung',
    auto_assignment: {
      title: 'Automatische Zuweisung',
      steps: {
        mode: {
          title: 'Typ auswählen',
          description:
            'Bitte wähle aus, ob du Mannschaften oder Nutzer automatisch zuweisen möchtest.',
          users: 'Nutzer',
          basketball_teams: 'Mannschaften',
        },
        events: {
          title: 'Terminauswahl',
          description:
            'Wähle die Termine aus, für die du die automatische Zuweisung durchführen möchtest.',
        },
        users: {
          title: 'Ausnahmen definieren',
          description:
            'Definiere Ausnahmen für die automatische Zuweisung. Die abgewählten Nutzer und Mannschaften werden für die Zuteilung nicht berücksichtigt.',
        },
        options: {
          title: 'Weitere Optionen',
          description: '',
          number_of_assignables: {
            title: 'Anzahl pro Termin',
            description:
              'Wie viele Nutzer/Mannschaften sollen pro Termin zugewiesen werden?',
          },
          consider_prev_assignments: {
            title: 'Ältere Zuweisungen',
            description:
              'Sollen ältere Zuweisungen berücksichtigt werden? Bsp: Wenn ein Nutzer in der Vergangenheit schon häufiger als andere Nutzer eingeteilt wurde, wird er für die automatische Zuweisung nicht mehr (bzw. seltener) berücksichtigt.',
            no: 'Nein',
            current_season: 'Aktuelle Saison (01.08. - 31.07.)',
            custom: 'Eigener Zeitraum',
          },
        },
        preview: {
          title: 'Vorschau',
          description:
            'Überprüfe und ändere gegebenfalls die automatischen Zuweisungen.',
        },
      },
    },
    create: 'Aufgabe erstellen',
    delete: 'Aufgabe löschen',
    edit: 'Aufgabe bearbeiten',
    more: 'Weitere Aufgaben',
    num_of_user_assignments: 'Anz. Einteilungen',
    num_of_user_assignments_more:
      'Anzahl aller Einteilungen. Diese Nummer kann bei Vereinsaufgaben ggf. höher sein als die Anzahl der ausgewählten Nutzer, da auch andere Mannschaften und Nutzer für diese Aufgabe eingeteilt werden können.',
    own_assignments: {
      allow: 'Eigene Zuweisungen erlauben',
      title: 'Eigene Zuweisungen',
    },
    past_events: {
      show: 'Vergangene Termine anzeigen',
      hide: 'Vergangene Termine ausblenden',
    },
    plural: 'Aufgaben',
    singular: 'Aufgabe',
    club: 'Vereinsaufgaben',
    requires_presence: {
      title: 'Anwesenheit erforderlich',
      description:
        'Wenn diese Option aktiviert ist, müssen die Nutzer bei der Aufgabe anwesend sein. Zudem wird diese Aufgabe bei der Konfliktprüfung berücksichtigt.',
    },
    single_user_assignment: {
      assign: {
        title: 'Aufgabe übernehmen',
        question:
          'Möchtest du diese Aufgabe wirklich übernehmen? Du kannst sie jederzeit wieder abgeben.',
      },
      give_up: {
        title: 'Aufgabe abgeben',
        question:
          'Möchtest du diese Aufgabe wirklich abgeben? Du kannst sie jederzeit wieder übernehmen.',
      },
    },
    team: 'Mannschaftsaufgaben',
    teams_assignments: 'Mannschaftszuweisungen',
    users_assignments: 'Nutzerzuweisungen',
    questions: {
      dont_take_over: 'Möchtest du diese Aufgabe doch nicht übernehmen?',
      take_over: 'Möchtest du diese Aufgabe übernehmen?',
      delete: 'Möchtest du diese Aufgabe wirklich löschen?',
    },
  },
  tbd: 'Offen',
  this_week: 'Diese Woche',
  team: 'Mannschaft',
  team_details: 'Mannschaftsdetails',
  team_profile: {
    photo: {
      edit: 'Mannschaftsbild bearbeiten',
      delete: 'Mannschaftsbild löschen',
    },
  },
  team_tan: 'Mannschaftsspezifische TA-Nummer',
  teams: 'Mannschaften',
  termination: {
    singular: 'Kündigung',
    plural: 'Kündigungen',
    add: 'Kündigung hinzufügen',
    edit: 'Kündigung bearbeiten',
    delete: 'Kündigung löschen',
    pending: 'Vorgemerkt',
    revoke: 'Kündigung widerrufen',
    info: {
      active:
        'Kündigung vorgemerkt: {{date}}. Nach Ablauf des Kündigungsdatums wird der Status automatisch auf „gekündigt“ gesetzt. Der Nutzer wird aus allen Mannschaften entfernt und kann Backcourt nicht mehr verwenden. Der Nutzer kann dann im Anschluss bei Bedarf manuell gelöscht werden.',
      none: 'Für diesen Nutzer liegen keine Kündigungen vor. Du kannst über das Formular unten eine Kündigung vormerken.',
    },
    form: {
      fields: {
        termination_date: 'Kündigungsdatum',
        reason: 'Grund',
      },
    },
    terminated: 'Gekündigt',
  },
  time: 'Uhrzeit',
  till: 'Bis',
  title: 'Titel',
  today: 'Heute',
  tomorrow: 'Morgen',
  transfer_players: 'Spieler verschieben',
  tutorials: {
    singular: 'Anleitung',
    plural: 'Anleitungen',
    alert: {
      button: 'Anleitung ansehen',
      empty_description:
        'Es wurde eine neue Anleitung hinzugefügt. Schau sie dir gleich an, damit du Backcourt noch besser nutzen kannst!',
    },
    button: {
      next: 'Weiter',
      done: 'Alles klar!',
    },
  },
  type: 'Typ',
  unknown: 'Unbekannt',
  upcoming: 'Demnächst',
  upcoming_club_games: {
    no_games: {
      title: 'Keine Spiele gefunden',
      description:
        'Es gibt keine Spiele, die deinen Filtereinstellungen entsprechen.',
    },
    past: 'Vergangen',
    title: 'Anstehende Vereinsspiele',
    upcoming: 'Demnächst',
    description:
      'Hier findest du alle anstehenden Spiele deines Vereins. Du kannst die Spiele nach Mannschaften filtern und dir Details zu jedem Spiel anzeigen lassen.',
  },
  upcoming_game: 'Nächstes Spiel',
  upcoming_league_games: 'Anstehende Ligaspiele',
  update: {
    title: 'Update',
    title_backcourt: 'Backcourt Update {{version}}',
    message_1_0_0:
      'Herzlich Willkommen im "neuen" Backcourt! Zusammen mit dem App Update 1.0.0 startet Backcourt mit einem komplett überarbeiteten System, welches in Zukunft noch schneller auf neue Anforderungen reagieren kann. Bestehende Funktion nicht gefunden? Klicke unten auf "Backcourt 0.21.1" (alte Version) um zur alten Backcourt Version zu gelangen. Alle noch fehlenden Funktionen werden in den kommenden Wochen nachgereicht. Fragen? Schaue unsere Hilfe Seite an oder kontaktiere uns!',
    message_1_1_0:
      'Das neue Update 1.1.0 bringt einige Änderungen mit sich. Die bisherigen fest definierten Aufgaben (Kampfgericht, Hallenverantwortung und Trikots bei Mannschaften) sind ab sofort obsolet. An ihrer Stelle gibt es nun die Funktion "Aufgaben". Diese Funktion war zuvor ausschließlich für Mannschaften verfügbar. Allerdings können nun auch Administratoren Aufgaben erstellen und sowohl Mannschaften als auch Nutzer zuordnen. Sobald Mannschaften für eine Aufgabe eingeteilt sind, können die Trainer ihre Spieler für diese bestimmen. Bereits bestehende Aufgaben werden zum 01.08. migriert.',
    modal: {
      text: 'Backcourt wurde auf Version {{version}} aktualisiert. Du kannst eine Liste mit allen Änderungen einsehen, indem du auf "Changelog" klickst.',
      button: 'Changelog',
    },
  },
  updated_at_time: 'Aktualisiert am {{date}}',
  url: 'URL',
  user: 'Nutzer',
  user_tasks: {
    singular: 'Aufgabe',
    plural: 'Aufgaben',
    inventory: {
      confirm: {
        title: 'Inventar-Übergabe bestätigen',
        description:
          'Bitte bestätige in deiner Inventarliste, dass du das Objekt {{name}} erhalten hast.',
      },
      confirm_return: {
        title: 'Inventar-Übergabe zurückgeben',
        description:
          'Bitte bestätige in der Inventarverwaltung, dass {{from}} das Objekt {{name}} zurückgegeben hat.',
      },
      return: {
        title: 'Inventar zurückgeben',
        description: {
          with_due_date:
            'Bitte gib das Objekt {{name}} bis zum {{date}} an den Inventarverwalter zurück.',
          without_due_date:
            'Bitte gib das Objekt {{name}} an den Inventarverwalter zurück.',
        },
      },
    },
  },
  version: 'Version',
  week: 'Woche',
  weekday: 'Wochentag',
  welcome_text: 'Willkommens-Text',
  widgets: 'Widgets',
  yes: 'Ja',
  yesterday: 'Gestern',
  zipcode: 'PLZ',
  scouting: {
    free_throws_short: 'FW',
    free_throws_long: 'Freiwürfe',
    fouls: 'Fouls',
    last_5: 'Letzte 5',
    load_report: 'Scoutingreport laden',
    loss_long: 'Niederlage',
    loss_short: 'N',
    losses: 'Niederlagen',
    minus: 'Minus',
    no_data: 'Keine Daten vorhanden',
    player_stats: 'Spielerstatistiken',
    plus: 'Plus',
    points_chart: 'Punkteverlauf',
    points: 'Punkte',
    quote: 'Quote',
    team_stats: 'Mannschaftsstatistiken',
    threes_long: 'Dreier',
    threes_short: '3er',
    win_long: 'Sieg',
    win_short: 'S',
    wins: 'Siege',
  },
  questions: {
    activate_users:
      'Möchtest du wirklich die ausgewählten Mitglieder aktivieren? Die Mitglieder erhalten nach der Aktivierung automatisch eine Willkommens-Email. Ausgewählte, bereits aktivierte Mitglieder werden ignoriert.',
    ask_delete_with_date:
      'Möchtest du diesen Eintrag vom {{date}} wirklich löschen?',
    ask_delete_with_type: 'Möchtest du dieses {{type}} wirklich löschen?',
    ask_take_over_with_date:
      'Möchtest du den Termin vom {{date}} wirklich übernehmen?',
    create_switch_request:
      'Für welchen Termin möchtests du eine Anfrage erstellen?',
    delete: 'Löschen? Achtung: Diese Aktion kann nicht widerrufen werden!',
    delete_game:
      'Möchtest du dieses Spiel wirklich löschen? Alle verknüpften Daten werden ebenfalls entfernt',
    delete_player:
      'Möchtest du wirklich {{player}} von dieser Mannschaft entfernen?',
    delete_players:
      'Möchtest du wirklich die ausgewählten Spieler von dieser Mannschaft entfernen?',
    delete_request: 'Möchtest du diese Anfrage wirklich löschen?',
    delete_users_one:
      'Möchtest du wirklich den ausgewählten Nutzer löschen? Die Aktion kann nicht rückgängig gemacht werden. Alle mit den Nutzern verknüpften Daten werden auch gelöscht.',
    delete_users_other:
      'Möchtest du wirklich die {{count}} ausgewählten Nutzer löschen? Die Aktion kann nicht rückgängig gemacht werden. Alle mit den Nutzern verknüpften Daten werden auch gelöscht.',
    forgot_password: 'Passwort vergessen?',
    invite_users:
      'Hier kannst du Mitglieder zu Backcourt einladen. Wir verschicken an jede valide Email-Adresse einen Link, unter welchem sich die eingeladenen Personen selbstständig registrieren können. Bitte erfasse pro Zeile nur eine E-Mail Adresse.',
    invite_users_link:
      'Einladungslink generieren? Der Link ist 48 Stunden gültig. Du kannst alle 24 Stunden einen neuen Link generieren.',
    send_welcome_mail:
      'Möchtest du eine Willkommens-Mail an die ausgewählten Mitglieder senden? Die Mitglieder erhalten in dieser einen Link, um ein Passwort für Backcourt zu setzen. Mitglieder welche bereits ein Passwort gesetzt haben werden ignoriert.',
    switch_account:
      'Möchtest du wirklich den Nutzer wechseln und als {{firstname}} {{lastname}} fortfahren?',
  },
  errors: {
    assign_users: 'Nutzer konnten nicht zugewiesen werden.',
    avatar_upload: {
      too_large: 'Bild darf maximal 2MB groß sein',
      wrong_format: 'Falsches Format',
    },
    basketball_coaches: {
      fetch: 'Trainer konnten nicht geladen werden.',
    },
    basketball_leagues: {
      sync: {
        too_many_requests:
          'Eine Synchronisierung ist nur alle 10 Minuten möglich.',
      },
    },
    basketball_users: {
      fetch: 'Nutzer konnten nicht geladen werden.',
      create: 'Nutzer konnte nicht erstellt werden.',
      update: 'Nutzer konnte nicht bearbeitet werden.',
      delete: 'Nutzer konnte nicht gelöscht werden.',
    },
    basketball_teams_fetch: 'Mannschaften konnten nicht geladen werden.',
    child_users_fetch: 'Fehler beim Laden deiner weiteren Accounts.',
    create_comment: 'Der Kommentar konnte nicht gesendet werden.',
    custom_user_attributes: {
      fetch: 'Vereinseigene Felder konnten nicht geladen werden.',
    },
    download: 'Die gewünschte Datei konnte nicht erzeugt werden.',
    generic: {
      create: 'Datensatz konnte nicht erstellt werden.',
      update: 'Datensatz konnte nicht bearbeitet werden.',
      delete: 'Datensatz konnte nicht gelöscht werden.',
    },
    gyms: {
      fetch: 'Sporthallen konnten nicht geladen werden.',
    },
    inventory: {
      transfers: {
        share_link_not_found: 'Der Link ist nicht gültig.',
      },
    },
    mail: 'Die E-Mail konnte nicht versendet werden. Versuche es später noch einmal oder wende dich an den Support.',
    load_more_comments: 'Es konnten keine weiteren Kommentare geladen werden.',
    login:
      'Falscher E-Mail Adresse und/oder falsches Passwort. Bitte versuche es noch einmal.',
    logout:
      'Hoopala, da lief was beim Logout schief. Probier es bitte noch einmal.',
    permissions: {
      first: 'Für diese Funktion benötigst du mindestens das Kreisliga Paket',
      second:
        'Für diese Funktion benötigst du mindestens das Regionalliga Paket',
      third: 'Für diese Funktion benötigst du mindestens das Bundesliga Paket',
      users:
        'Du hast für dein Paket die maximale Anzahl an Nutzern bereits erreicht.',
      basketball_teams:
        'Du hast für dein Paket bereits die maximale Anzahl an Mannschaften erreicht.',
      tasks:
        'Du hast für dein Paket bereits die maximale Anzahl an Aufgaben erreicht.',
      practice_time_schedules:
        'Du hast für dein Paket bereits die maximale Anzahl an Trainingspläne erreicht.',
    },
    practice_time: {
      save: 'Trainingszeit konnte nicht gespeichert werden.',
      delete: 'Trainingszeit konnte nicht gelöscht werden.',
    },
    register_user:
      'Registrierung konnte nicht durchgeführt werden. Probiere es noch einmal oder wende dich an den Support.',
    reset_password:
      'Das Passwort konnte nicht zurück gesetzt werden. Versuche es später noch einmal oder wende dich an den Support.',
    single_game_fetch: 'Spiel konnte nicht geladen werden.',
    single_practice_fetch: 'Training konnte nicht geladen werden.',
    stripe: {
      fetch_products: 'Produkte konnten nicht geladen werden.',
    },
    switch_requests: {
      create: 'Anfrage konnte nicht erstellt werden.',
      delete: 'Anfrage konnte nicht gelöscht werden.',
      fetch: 'Anfragen konnten nicht geladen werden.',
      fetch_possible_games:
        'Deine möglichen Wechseltermine konnten nicht geladen werden.',
      fetch_possible_tasks: 'Deine Aufgaben konnten nicht geladen werden.',
      take_over: 'Aufgabe konnte nicht übernommen werden.',
    },
    tasks: {
      assignment:
        'Aufgabe konnte nicht zugewiesen werden. Bitte beachte die Anzahl der Nutzer die für diese Aufgabe benötigt werden.',
      min_number_of_users:
        'Mindestanzahl der Nutzer ({{min}}) wurde nicht erreicht.',
      max_number_of_users: 'Maximale Anzahl der Nutzer wurde erreicht.',
    },
    token_invalid:
      'Der Link ist nicht gültig oder die eingegebene E-Mail Adresse stimmt nicht. Bitte prüfe deine Eingabe oder fordere einen neuen Link an.',
    token_invalid_registration:
      'Es gibt ein Problem mit dem Link! Der Link ist nicht (mehr) gültig oder dein Verein hat die maximale Anzahl an Nutzern erreicht. Melde dich bei deinem Verein. Dieser kann die Limitierung überprüfen und dir ggf. einen neuen Link zusenden.',
    undefined: 'Unbekannter Fehler',
    update_game: 'Das Spiel konnte nicht aktualisiert werden.',
    update_reply: 'Antwort konnte nicht geändert werden.',
    update_judge_user: {
      already_exists:
        'Die ausgewählte Person ist für dieses Spiel bereits am Kampfgericht eingeteilt.',
    },
    users: {
      activate: 'Mitglieder konnten nicht aktiviert werden',
      delete_multi: 'Mitglieder konnten nicht gelöscht werden',
      update_children: 'Verknüpfte Konten konnten nicht gespeichert werden',
      update_user_rights: 'Rechte konnten nicht gespeichert werden',
      no_selection: 'Keine Nutzer ausgewählt',
      has_inventory:
        'Der Nutzer {{name}} hat noch folgende Inventar-Objekte zugewiesen: {{inventoryList}}. Stelle sicher, dass das Inventar wieder zurückgegeben wurde. Beim Löschen des Nutzers wird das Inventar wieder dem Vereinslager zugeordnet.',
    },
    userdata: 'Nutzerdaten konnten nicht geladen werden.',
    users_import: 'Mitglieder konnten nicht importiert werden.',
  },
  form_errors: {
    date: 'Bitte gebe ein Datum ein',
    date_range: 'Bitte gebe ein Datumsbereich ein',
    email: 'Bitte gebe eine korrekte E-Mail Adresse ein',
    gym: 'Bitte eine Sporthalle auswählen',
    location: 'Bitte einen Ort eingeben',
    max_chars: 'Maximal {{max}} Zeichen erlaubt',
    name: 'Bitte einen Namen eingeben',
    no_own_team: 'Bitte wähle ein Team aus, welches du trainierst',
    number: 'Bitte eine ganze Zahl eingeben',
    number_min: 'Die Zahl darf nicht kleiner als {{min}} sein',
    number_max: 'Die Zahl darf nicht größer als {{max}} sein',
    password: 'Bitte gebe ein Passwort ein',
    password_length: 'Bitte gebe mindestens 8 Zeichen ein',
    password_confirm: 'Die Passwörter stimmen nicht überein',
    privacy: 'Bitte aktzeptiere die Datenschutzerklärung',
    recipient: 'Bitte gebe einen Empfänger ein',
    same_team: 'Bitte unterschiedliche Mannschaften wählen',
    select_value: 'Bitte eine Option auswählen',
    sex: 'Bitte ein Geschelecht eingeben',
    text: 'Bitte gebe einen Text ein',
    time: 'Bitte gebe eine Uhrzeit ein',
    title: 'Bitte gebe einen Titel ein',
    user_consent: 'Einverständniserklärung muss vorhanden sein',
    value: 'Bitte einen Wert eingeben',
    weekday: 'Bitte ein Wochentag auswählen',
  },
  greetings: {
    good_day: 'Guten Tag',
    good_morning: 'Guten Morgen',
    good_evening: 'Guten Abend',
    hello: 'Hallo',
  },
  information_texts: {
    create_request: 'Du kannst eine neue Anfrage über den + Button stellen',
    check_inbox:
      'Bitte prüfe in einigen Minuten dein Mail-Postfach. Schaue auch in deinem Spam-Ordner, falls du keine E-Mail erhalten hast!',
    club_information: 'Nachfolgend einige Informationen von deinem Verein',
    coming_soon_in_app_go_to_web:
      'Diese Funktion ist aktuell nur in der Web-Version verfügbar',
    edit_practices:
      'Leere Felder werden ignoriert und nicht bei den ausgewählten Einheiten übernommen.',
    empty_view: 'Nichts los hier...',
    forgot_password:
      'Passwort vergessen? Kein Problem, gib einfach deine E-Mail Adresse ein und wir schicken dir ein neues zu!',
    found_mail_addresses: '{{number}} E-Mail Adressen gefunden',
    input_tan:
      'Bitte letzte 3 Ziffern der TA-Nummer ohne führende Nullen erfassen. Führende Nullen werden automatisch aufgefüllt.',
    is_public:
      'Die Aufgabe ist für alle in den Termindetails ersichtlich. Nutzer können sich für diese Aufgabe einteilen.',
    jerseys: 'Du musst dieses Spiel die Trikots waschen!',
    linked_accounts:
      'Hier können Sie zu verknüpfende Konten für den Benutzer erfassen. Dies ist sinnvoll, wenn der Benutzer keine eigene E-Mail-Adresse hat oder andere Benutzer das Konto verwalten sollen. In dieser Spalte müssen E-Mail-Adressen durch ein Komma getrennt sein und mit einem bereits bestehenden oder zu importierenden Konto übereinstimmen. (Bsp.: mail1@example.com,mail2@example.com)',
    login_error: 'Nutzername/Passwort falsch. Bitte versuche es erneut.',
    max_participants: 'Maximale Anzahl an Teilnehmer erreicht',
    no_changes: 'Es wurden noch keine Änderungen vorgenommen',
    no_data: 'Keine Daten vorhanden',
    no_games: 'Keine Spiele verfügbar',
    no_notification_settings:
      'Du hast noch keine Benachrichtungen aktiviert! Passe deine Einstellungen an um immer Up-to-date zu bleiben!',
    no_requests: 'Keine Anfragen verfügbar',
    no_standings: 'Keine Tabelle verfügbar',
    no_squad: 'Keine Mannschaftsinformationen verfügbar',
    no_switch_possible:
      'Anfragen können nicht erstellt oder beantwortet werden',
    no_upcoming_events:
      'Es gibt keine anstehenden Termine in der nächsten Zeit',
    no_user_events: 'Dein Kalender ist leer – der Freiplatz wartet auf dich!',
    notification_settings:
      'Nehme deine Änderungen vor. Wenn du für nichts benachrichtigt werden willst, tippe einfach nur auf Speichern.',
    permissions: {
      camera_roll:
        'Wir benötigen Zugriff auf deine Fotogalerie. Bitte gebe uns Zugriff in den Einstellungen deines Geräts!',
      file_system:
        'Wir benötigen Zugriff auf das Dateisystem. Bitte gebe uns Zugriff in den Einstellungen deines Geräts!',
    },
    read_privacy: 'Ja, ich habe die Datenschutzhinweise (FAQ) gelesen.',
    registration_successful:
      'Registrierung erfolgreich! Ab sofort hast du deine Termine immer auf einen Blick! Achtung: Dein Terminkalender wird noch leer sein, bis dein Verein dich einer/mehreren Mannschaft(en) zugeteilt hat. Du kannst in der Zwischenzeit jedoch schon einmal deine Benachrichtigungseinstellungen anpassen.',
    reply_reason:
      'Dein Trainer möchte den Grund wissen, warum du an diesem Termin nicht teilnehmen kannst.',
    reset_password:
      'Hier kannst du dein neues Passwort setzen. Gebe zudem deine E-Mail Adresse ein, über welche du zu dieser Seite gelangt bist.',
    sent_mail_if_known:
      'Wir haben dir eine E-Mail zugesendet, sofern ein Konto mit dieser E-Mail Adresse vorhanden ist.',
    save_reminder:
      'Nicht gespeicherte Änderungen! Speichere deine Änderungen, indem du auf den Speichern Button klickst.',
    save_reminder_bottom:
      'Nicht gespeicherte Änderungen! Speichere deine Änderungen, indem du am Ende dieser Seite auf den Speichern Button klickst.',
    saving_error: 'Fehler beim Speichern. Bitte versuche es erneut.',
    select_possible_event:
      'Wähle einen Termin aus, falls du die ausgewählte Anfrage mit einem deiner Termine tauschen möchtest.',
    set_player_settings:
      'Du kannst nach dem Speichern weitere Einstellungen wie zb. Trikotnummer oder Captain vornehmen.',
    set_team_settings:
      'Du kannst nach dem Speichern weitere Einstellungen wie zb. Trainer oder Trainingszeiten vornehmen.',
    sort_list_description: 'Tippe und halte ein Element um es zu verschieben',
    take_over_by: 'Termin wurde von {{user}} übernommen.',
    team_changed: 'Mannschaft gewechselt',
    transfer_players:
      'In welche Mannschaft möchtest du die ausgewählten Spieler verschieben? Die ausgewählten Spieler werden von dieser Mannschaft entfernt.',
    user_consent:
      'Ich bestätige, dass ich das Einverständnis habe, die persönlichen Daten dieses Nutzers zu erfassen/bearbeiten.',
    user_consent_2:
      'Falls das Einverständnis nicht vorhanden ist, kann die "Mitglied einladen" Funktion genutzt werden.',
    user_created_event: '{{user}} hat das Ereignis erstellt',
    user_pending: 'Der Benutzer hat sich noch nicht bei Backcourt angemeldet',
    user_updated_event: '{{user}} hat eine Änderung vorgenommen',
  },
  load_more: {
    comments: 'Ältere Kommentare laden',
    events: 'Ältere Termine laden (bis {{date}})',
    messages: 'Ältere Nachrichten laden',
    notifications: 'Ältere Benachrichtigungen laden',
    switch_requests: {
      show: 'Ältere Anfragen anzeigen',
      hide: 'Ältere Anfragen ausblenden',
    },
  },
  marketing_texts: {
    description:
      'Backcourt ist dein Begleiter während der Basketball-Saison! Egal ob du Trainer, Spieler, Schiedsrichter oder Organisator bist, Backcourt vereint alle Mitwirkenden deines Vereins in einer Software.',
    download_app: 'App runterladen',
    login:
      'Mit Backcourt hast du die Termine deines Basketballvereins stets im Blick!',
    welcome_to_backcourt: 'Herzlich Willkommen bei Backcourt!',
  },
  setting_texts: {
    requireReplyReason: {
      title: 'Grund angeben',
      description: 'Spieler müssen bei einer Terminabsage einen Grund angeben',
    },
    allowViewReplies: {
      title: 'Anwesenheiten anzeigen',
      description:
        'Spieler können die Anwesenheitsantwort von Mitspielern einsehen',
    },
    defaultYesReply: {
      title: 'Standardmäßig anwesend',
      description: 'Spieler werden standardmäßig als anwesend markiert',
      games: {
        title: '',
        description: 'Bei Spielen',
      },
      practices: {
        title: '',
        description: 'Bei Trainingseinheiten',
      },
    },
  },
  success: {
    generic: {
      create: 'Datensatz erstellt.',
      update: 'Datensatz bearbeitet.',
      delete: 'Datensatz gelöscht.',
    },
    reset_password:
      'Passwort erfolgreich zurückgesetzt. Du kannst dich ab sofort mit deinem neuen Passwort anmelden.',
    send_welcome_mail: 'Nutzer wurden benachrichtigt.',
  },
  users: {
    deleted_user: {
      firstname: 'Gelöschter',
      lastname: 'Nutzer',
    },
    email_addresses: {
      singular: 'E-Mail Adresse',
      plural: 'E-Mail Adressen',
      add: 'E-Mail Adresse hinzufügen',
      edit: 'E-Mail Adresse bearbeiten',
      delete: 'E-Mail Adresse löschen',
      description:
        'Hier kannst du weitere E-Mail Adressen für den Nutzer hinterlegen. Diese können für den Erhalt von Benachrichtigungen verwendet werden.',
      form: {
        fields: {
          email: 'E-Mail Adresse',
          description: 'Beschreibung',
          use_for_notifications: 'Für Benachrichtigungen verwenden',
        },
      },
    },
    users: 'Nutzer',
    invitation_links: {
      singular: 'Einladungslink',
      generate: 'Einladungslink generieren',
      valid_until: 'Gültig bis',
      valid_for: 'Gültig für',
      valid_for_all_teams: 'Alle Mannschaften',
      form: {
        team_info:
          'Der Nutzer wird dieser Mannschaft direkt bei der Registrierung zugewiesen. Dieses Feld ist optional.',
      },
    },
    user_data: {
      title: 'Nutzerdaten',
      update: {
        admin_info:
          'Bitte wende dich an einen Administrator oder Trainer, um deine Nutzerdaten zu aktualisieren.',
      },
    },
  },
  users_importer: {
    alternative_ctrl_v:
      'Alternativ kann auch der Inhalt der CSV kopiert und hier mittels Strg+V einfach eingefügt werden.',
    auto_activate:
      'Nach Import neu hinzugefügte Mitglieder aktivieren und automatische Willkommens-Mail schicken?',
    auto_activate_title: 'Mitglieder automatisch aktivieren',
    columns_must_match: 'Anzahl der Spalten muss übereinstimmen!',
    columns_not_matching:
      'Anzahl der Spalten stimmt nicht überein! Erwartet: {{expected}} Gefunden: {{received}}. Diese Zeile kann nicht in der Vorschautabelle angezeigt werden.',
    continue_with: 'Weiter mit {{number}} Zeilen',
    csv_separator: 'CSV Trennzeichen',
    drop_csv_here: 'Bitte CSV in diesem Feld fallen lassen.',
    num_of_users: 'Anzahl der Mitglieder',
    num_of_valid_rows:
      'Von {{total}} eingefügten Zeilen sind {{valid}} korrekt.',
    step_0: 'Spalten auswählen',
    step_1: 'Daten einfügen',
    step_2: 'Einstellungen',
    step_3: 'Überprüfen',
    hint_own_fields:
      'Hinweis: Du kannst eigene Felder in den Vereinseinstellungen definieren.',
  },
  user_invitation: {
    copied_to_clipboard: 'Link in die Zwischenablage kopiert',
    warning:
      'Achtung: Mit diesem Link können sich Personen bei Backcourt registrieren! Achte daher darauf, wem du den Link weiterleitest.',
  },
  weekdays: {
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',
  },
};
